import React, { useState } from 'react';
import {
  Brain,
  Eye,
  EyeOff,
  ChevronDown,
  ChevronUp,
  Lightbulb,
  Target,
  TrendingUp,
  AlertTriangle
} from 'lucide-react';
import EnhancedHTMLRenderer from './EnhancedHTMLRenderer';
import MarkdownRenderer from '../diagnosis/MarkdownRenderer';

interface DeepAnalysisDisplayProps {
  analysis: {
    full_article?: string;
    preview_content?: string;
    content_json?: {
      thinking_process?: string;
      format?: string;
      [key: string]: any;
    };
  };
  title?: string;
  showThinkingProcess?: boolean;
}

const DeepAnalysisDisplay: React.FC<DeepAnalysisDisplayProps> = ({
  analysis,
  title = "AI深度分析",
  showThinkingProcess = true
}) => {
  // 检查内容是否为HTML格式
  const isHTMLContent = (content: string): boolean => {
    return /<[^>]+>/.test(content);
  };

  // 渲染内容的通用函数
  const renderContent = (content: string, className: string = "") => {
    if (isHTMLContent(content)) {
      return (
        <EnhancedHTMLRenderer
          content={content}
          className={className}
        />
      );
    } else {
      return (
        <MarkdownRenderer
          content={content}
          className={className}
          enableSyntaxHighlight={true}
          theme="light"
        />
      );
    }
  };

  // 只使用 full_article 字段
  const mainContent = analysis.full_article || analysis.preview_content;

  return (
    <div className="deep-analysis-display">
      {/* 标题区域 */}
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
          <Brain className="w-6 h-6 text-blue-600 mr-3" />
          {title}
        </h2>
        <p className="text-gray-600">
          基于专业分析框架生成的深度洞察，帮助您全面理解事件背景和影响。
        </p>
      </div>

      {/* 内容区域 - 直接显示 full_article 内容 */}
      <div className="analysis-content">
        {mainContent ? (
          <div className="main-analysis-content">
            {renderContent(mainContent, "prose prose-lg max-w-none")}
          </div>
        ) : (
          <div className="text-center py-12">
            <AlertTriangle className="w-12 h-12 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">暂无分析内容</h3>
            <p className="text-gray-500">
              分析内容正在生成中，请稍后刷新页面查看。
            </p>
          </div>
        )}
      </div>

    </div>
  );
};

export default DeepAnalysisDisplay;